/**
 * 쿼리챌린지 「평가 기준」 창 — SQL 작성(001)·선택형(002)을 무엇으로 몇 점 매기는지(2026-10-05).
 *
 * 숫자는 **채점이 쓰는 값**에서 읽는다 — 결과 비교는 `utils/queryGrading`, 제출 횟수·시간·점수는 `config/quizTypes`.
 * 창에 숫자를 따로 적으면 채점이 바뀔 때 창만 남아 거짓말을 한다(튜닝챌린지 「평가 기준」 창과 같은 규칙).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiAward } from 'react-icons/fi';
import AppModal from '../common/AppModal';
import { getQuizConfig } from '../../config/quizTypes';
import { COMPARE_ROWS, FETCH_ROWS } from '../../utils/queryGrading';

const h = { margin: '10px 0 4px', fontSize: 12, fontWeight: 700 };

export default function QueryRubricDialog({ open, onClose, kind = '001' }) {
  const { t } = useTranslation();
  const sql = getQuizConfig('001') || {};
  const mc = getQuizConfig('002') || {};
  const pts = (cfg) => (cfg.scoring && cfg.scoring.correctAnswer) || 100;

  const sqlPart = (
    <>
      <div style={h}>{t('challenge:queryRubric.sqlTitle')}</div>
      <ol style={{ margin: 0, paddingLeft: 18 }}>
        <li>{t('challenge:queryRubric.sqlRules')}</li>
        <li>{t('challenge:queryRubric.sqlCompare', { rows: COMPARE_ROWS })}</li>
        <li>{t('challenge:queryRubric.sqlCount', { max: FETCH_ROWS })}</li>
        <li>{t('challenge:queryRubric.sqlDates')}</li>
        <li>{t('challenge:queryRubric.sqlError')}</li>
        <li>{t('challenge:queryRubric.sqlScore', { points: pts(sql) })}</li>
        <li>{t('challenge:queryRubric.sqlSubmit')}</li>
      </ol>
      <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 4 }}>
        <div>· {t('challenge:queryRubric.sqlDb')}</div>
        <div>· {t('challenge:queryRubric.sqlTips', { rows: COMPARE_ROWS })}</div>
        <div>· {t('challenge:queryRubric.sqlNoPerf')}</div>
      </div>
    </>
  );
  const mcPart = (
    <>
      <div style={h}>{t('challenge:queryRubric.mcTitle')}</div>
      <ol style={{ margin: 0, paddingLeft: 18 }}>
        <li>{t('challenge:queryRubric.mcAnswer')}</li>
        <li>{t('challenge:queryRubric.mcScore', { points: pts(mc) })}</li>
        <li>{t('challenge:queryRubric.mcSubmit', { n: mc.maxSubmissions || 3 })}</li>
        <li>{mc.timeLimit
          ? t('challenge:queryRubric.mcTime', { sec: mc.timeLimit, min: Math.round(mc.timeLimit / 60) })
          : t('challenge:queryRubric.mcNoTime')}</li>
      </ol>
    </>
  );

  return (
    <AppModal open={open} onClose={onClose} title={t('challenge:queryRubric.title')} icon={<FiAward size={14} />} closeOnBackdrop>
      <div style={{ padding: 12, fontSize: 12, lineHeight: 1.6, color: 'var(--color-text)' }}>
        <p style={{ margin: '0 0 4px' }}>{t('challenge:queryRubric.intro')}</p>
        {/* 지금 문항의 유형을 먼저 — 다른 유형은 뒤에 */}
        {kind === '002' ? <>{mcPart}{sqlPart}</> : <>{sqlPart}{mcPart}</>}
      </div>
    </AppModal>
  );
}

/**
 * 문항 제목줄에 다는 「평가 기준」 버튼 + 창 — 001 제목줄 두 곳과 002 제목줄이 **같은 것**을 쓴다(베끼면 한 곳만 고쳐진다).
 */
export function QueryRubricButton({ kind = '001', style }) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title={t('challenge:queryRubric.buttonHint')}
        style={{
          fontSize: 10, fontWeight: 'normal', padding: '2px 8px', borderRadius: 3,
          display: 'inline-flex', alignItems: 'center', gap: 4,
          background: 'var(--color-bg-secondary)', color: 'var(--color-text)', border: '1px solid var(--color-border)',
          cursor: 'pointer', transition: 'background 150ms ease, border-color 150ms ease',
          ...style,
        }}
      >
        <FiAward size={11} />
        {t('challenge:rubric.button')}
      </button>
      <QueryRubricDialog open={open} onClose={() => setOpen(false)} kind={kind} />
    </>
  );
}
